import { render, staticRenderFns } from "./FieldSalesTab.vue?vue&type=template&id=4afa7afd&"
import script from "./FieldSalesTab.vue?vue&type=script&lang=js&"
export * from "./FieldSalesTab.vue?vue&type=script&lang=js&"
import style0 from "./FieldSalesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCarousel,QCarouselControl,QBtn,QCarouselSlide,QCardSection,QImg,QTabs,QTab,QBtnToggle,QRouteTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCarousel,QCarouselControl,QBtn,QCarouselSlide,QCardSection,QImg,QTabs,QTab,QBtnToggle,QRouteTab,QTabPanels,QTabPanel})
